import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98bac8b4")

_pushScopeId("data-v-98bac8b4")
const _hoisted_1 = {
  class: "p-grid",
  style: {"min-height":"40vh","margin-bottom":"-3rem"}
}
const _hoisted_2 = { class: "p-d-flex p-jc-between" }
const _hoisted_3 = {
  key: 0,
  class: "sub-tabview"
}
const _hoisted_4 = {
  key: 2,
  class: "p-d-flex p-jc-center p-pb-3"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "p-col-3" }
const _hoisted_9 = { class: "p-datatable p-datatable-sm variable-data-table" }
const _hoisted_10 = { class: "p-datatable-table" }
const _hoisted_11 = { class: "p-datatable-tbody" }
const _hoisted_12 = { class: "p-text-bold" }
const _hoisted_13 = { class: "p-text-bold" }
const _hoisted_14 = { class: "p-text-bold" }
const _hoisted_15 = { class: "p-text-bold" }
const _hoisted_16 = { class: "p-text-bold" }
const _hoisted_17 = { class: "p-text-bold" }
const _hoisted_18 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_19 = { class: "p-datatable p-datatable-sm variable-data-table" }
const _hoisted_20 = { class: "p-datatable-table" }
const _hoisted_21 = { class: "p-datatable-tbody" }
const _hoisted_22 = { class: "p-text-bold" }
const _hoisted_23 = { class: "p-text-bold" }
const _hoisted_24 = { class: "p-col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "p-col-6",
      style: [
        _ctx.variable.type == 'Categorical'
          ? { maxHeight: '26vh' }
          : { maxHeight: '30vh' },
      ]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("b", null, _toDisplayString(_ctx.name), 1),
        (_ctx.variable.type == 'Numeric' && _ctx.variable.common_values)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_Button, {
                class: ["p-button-sm", _ctx.getCssClass(0)],
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = 0)),
                label: _ctx.$t('datasource.options.common.value')
              }, null, 8, ["class", "label"]),
              _createVNode(_component_Button, {
                class: ["p-button-sm", _ctx.getCssClass(1)],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = 1)),
                label: _ctx.$t('datasource.options.histogram')
              }, null, 8, ["class", "label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.variable.type == 'Numeric' && _ctx.active == 0)
        ? (_openBlock(), _createBlock(_component_v_chart, {
            key: 0,
            class: "chart",
            option: _ctx.optionCommonValue,
            theme: _ctx.theme,
            autoresize: ""
          }, null, 8, ["option", "theme"]))
        : (_openBlock(), _createBlock(_component_v_chart, {
            key: 1,
            class: "chart",
            option: _ctx.option,
            theme: _ctx.theme,
            autoresize: ""
          }, null, 8, ["option", "theme"])),
      (_ctx.option || _ctx.optionCommonValue)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.variable.type == 'Categorical')
              ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("datasource.histogram.category.title")), 1))
              : (_ctx.variable.type == 'Numeric' && _ctx.active == 0)
                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("datasource.histogram.top.common.values")), 1))
                : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("datasource.histogram.fixed_bin_size.title", {
            bin: _ctx.variable.histogram.counts.length,
          })), 1))
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("table", _hoisted_10, [
          _createVNode("tbody", _hoisted_11, [
            _createVNode("tr", null, [
              _createVNode("td", _hoisted_12, _toDisplayString(_ctx.$t("datasource.metadata.role")), 1),
              _createVNode("td", null, [
                _createVNode(_component_DataRole, {
                  role: _ctx.variable.type
                }, null, 8, ["role"])
              ])
            ]),
            _createVNode("tr", null, [
              _createVNode("td", _hoisted_13, _toDisplayString(_ctx.$t("datasource.metadata.n_distinct")), 1),
              _createVNode("td", null, _toDisplayString(_ctx.variable.n_distinct) + " (" + _toDisplayString((_ctx.variable.p_distinct * 100).toFixed(2)) + "%) ", 1)
            ]),
            _createVNode("tr", null, [
              _createVNode("td", {
                class: ["p-text-bold", {
                  'p-error': _ctx.variable.n_missing > 0,
                }]
              }, _toDisplayString(_ctx.$t("datasource.metadata.n_missing")), 3),
              _createVNode("td", {
                class: {
                  'p-error': _ctx.variable.n_missing > 0,
                }
              }, _toDisplayString(_ctx.variable.n_missing) + " (" + _toDisplayString((_ctx.variable.p_missing * 100).toFixed(2)) + "%) ", 3)
            ]),
            (_ctx.variable.type == 'Numeric')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_14, _toDisplayString(_ctx.$t("datasource.metadata.n_infinite")), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.variable.n_infinite) + " (" + _toDisplayString((_ctx.variable.p_infinite * 100).toFixed(2)) + "%) ", 1)
                  ]),
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_15, _toDisplayString(_ctx.$t("datasource.metadata.mean")), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.variable.mean?.toFixed(2)), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.variable.type == 'DateTime')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_16, _toDisplayString(_ctx.$t("datasource.metadata.min")), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.variable.min), 1)
                  ]),
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_17, _toDisplayString(_ctx.$t("datasource.metadata.max")), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.variable.max), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.variable.type == 'Numeric')
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("table", _hoisted_20, [
              _createVNode("tbody", _hoisted_21, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_22, _toDisplayString(_ctx.$t("datasource.metadata.min")), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.variable.min), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_23, _toDisplayString(_ctx.$t("datasource.metadata.max")), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.variable.max), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", {
                    class: ["p-text-bold", {
                  'p-error': _ctx.variable.n_zeros > 0,
                }]
                  }, _toDisplayString(_ctx.$t("datasource.metadata.n_zeros")), 3),
                  _createVNode("td", {
                    class: {
                  'p-error': _ctx.variable.n_zeros > 0,
                }
                  }, _toDisplayString(_ctx.variable.n_zeros) + " (" + _toDisplayString((_ctx.variable.p_zeros * 100).toFixed(2)) + "%) ", 3)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", {
                    class: ["p-text-bold", {
                  'p-error': _ctx.variable.n_negative > 0,
                }]
                  }, _toDisplayString(_ctx.$t("datasource.metadata.n_negative")), 3),
                  _createVNode("td", {
                    class: {
                  'p-error': _ctx.variable.n_negative > 0,
                }
                  }, _toDisplayString(_ctx.variable.n_negative) + " (" + _toDisplayString((_ctx.variable.p_negative * 100).toFixed(2)) + "%) ", 3)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_24, [
      _createVNode(_component_Divider)
    ])
  ]))
})